import React, { useState, useEffect } from 'react';
import { useAcceptanceChangeStore } from 'src/store/acceptance-change';
import { useAuthStore } from 'src/store/auth';
import { useApplicationStore } from 'src/store/application';
import { format } from 'date-fns';
import { useGeneralStore } from 'src/store';
import { Modal } from '../Modal';
import './AcceptanceWarningModal.scss';

export const AfterSignIn: React.FC = () => {
  const {
    isModalOpen,
    setModalOpen,
    resetAcceptance,
    checkApplicationStatus,
    // setDontShowAgain,
  } = useAcceptanceChangeStore();
  const { siteConfig } = useGeneralStore();
  const { isAuthenticated } = useAuthStore();
  const [isProcessing, setIsProcessing] = useState(false);
  const { signedAt } = useApplicationStore();

  // Check application status on mount
  useEffect(() => {
    if (isAuthenticated) {
      checkApplicationStatus(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  const handleProceed = async () => {
    setIsProcessing(true);
    try {
      await resetAcceptance();
      setModalOpen(false);
    } catch (error) {
      console.error('Failed to reset acceptance:', error);
    } finally {
      setIsProcessing(false);
    }
  };

  const handleCancel = () => {
    setModalOpen(false);
  };

  const handleClose = () => {
    setModalOpen(false);
  };

  // const handleDontShowAgain = () => {
  //   setDontShowAgain();
  // };

  if (!isModalOpen) return null;

  return (
    <Modal isOpen={isModalOpen} onClose={handleClose} className="acceptance-warning-modal">
      <div className="acceptance-warning">
        <div className="acceptance-warning__image">
          <img 
            src="/images/modalUnderReview.jpg" 
            alt="Application changes warning"
            className="acceptance-warning__image-content"
          />
        </div>

        <div className="acceptance-warning__content">
          <div className="acceptance-warning__text">
            <p className="acceptance-warning__paragraph">
              Thanks for completing your application. Since your contract was signed on <strong className="">{format(new Date(`${signedAt}`), 'd MMMM, yyyy')}</strong>, your selections are now <strong>locked</strong>.
              Please <strong>complete the payment step</strong> to activate your coverage.
            </p>
            <p className="acceptance-warning__paragraph">
              Need to fix something? Email <a href={`mailto:${siteConfig?.emails?.primary||''}`}><strong>{siteConfig?.emails?.primary||''}</strong></a> before paying and we’ll help.
            </p>
          </div>

          <div className="acceptance-warning__actions">
            <button
              className="acceptance-warning__button acceptance-warning__button--cancel"
              onClick={handleClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
